module.exports = __webpack_public_path__ + "fonts/manrope-regular.b3678617.otf";